export default async function findUserType() {
  return await JSON.parse(localStorage.getItem("authUser"))?.role;
}
